import {
  AppBar,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from "@mui/material";
import React, { useContext } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import username from "../../assets/images/username.png";
import { logoutIcon, prevIcon } from "../../assets/uppoIcons/icons";
import { updateBreadcrumbTitle } from "../../utils";
import { AuthContext } from "../auth/context/Context";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";
const Header: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const { logout, user } = useContext(AuthContext);
  const open = Boolean(anchorEl);
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar position="sticky">
      <Toolbar>
        <IconButton edge="start" color="inherit" aria-label="menu">
          {/* <MenuIcon /> */}
        </IconButton>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Typography
            variant="h6"
            sx={{ display: "flex", alignItems: "center" }}
          >
            {" "}
            {!location.pathname.includes("vendors") && (
              <KeyboardArrowLeftOutlinedIcon
                sx={{ cursor: "pointer" }}
                color="inherit"
                onClick={() => navigate(-1)}
              />
            )}
            {updateBreadcrumbTitle(location.pathname, id)?.map(
              (label: any, index: number) => {
                return index !=
                  updateBreadcrumbTitle(location.pathname)?.length - 1
                  ? label + " - "
                  : label;
              }
            )}
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: "14px" }}>
            <Typography sx={{ fontSize: "20px", fontWeight: 700 }}>
              {user?.name}
            </Typography>
            <Box
              sx={{
                height: "32px",
                width: "32px",
              }}
            >
              <AccountCircleOutlinedIcon
                onClick={(e) => handleClick(e)}
                sx={{
                  height: "32px",
                  width: "32px",
                  margin: "0px",
                  cursor: "pointer",
                }}
              />
            </Box>
            {/* <img
              src={username}
              alt=""
              style={{
                height: "32px",
                width: "32px",
                margin: "0px",
                cursor: "pointer",
              }}
            /> */}
          </Box>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
            sx={{ position: "absolute", top: "19px" }}
          >
            <MenuItem
              onClick={() => logout()}
              sx={{
                display: "flex",
                gap: "10px",
                width: "222px",
                fontWeight: 700,
              }}
            >
              {logoutIcon} Sair{" "}
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
